import { render, staticRenderFns } from "./CreditInsuranceList.vue?vue&type=template&id=4b914f23&scoped=true&"
import script from "./CreditInsuranceList.vue?vue&type=script&lang=ts&"
export * from "./CreditInsuranceList.vue?vue&type=script&lang=ts&"
import style0 from "./CreditInsuranceList.vue?vue&type=style&index=0&id=4b914f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b914f23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VDataTable})
